import p from "./ghl-ui.es1589.js";
import l from "./ghl-ui.es1590.js";
import o from "./ghl-ui.es1586.js";
import f from "./ghl-ui.es1587.js";
import u from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as c } from "./ghl-ui.es1670.js";
import { parseAnyDigitsSigned as h } from "./ghl-ui.es1671.js";
var S = /* @__PURE__ */ function(m) {
  f(t, m);
  var a = u(t);
  function t() {
    var r;
    p(this, t);
    for (var i = arguments.length, s = new Array(i), e = 0; e < i; e++)
      s[e] = arguments[e];
    return r = a.call.apply(a, [this].concat(s)), n(o(r), "priority", 20), n(o(r), "incompatibleTokens", "*"), r;
  }
  return l(t, [{
    key: "parse",
    value: function(i) {
      return h(i);
    }
  }, {
    key: "set",
    value: function(i, s, e) {
      return [new Date(e), {
        timestampIsSet: !0
      }];
    }
  }]), t;
}(c);
export {
  S as TimestampMillisecondsParser
};
